var customDefaultOptions = {
    scrollThrottlingTime: 0,
    scrollDebounceTime: 0,
    scrollAnimationTime: 0,
    checkResizeInterval: 0,
    resizeBypassRefreshThreshold: 5,
};
var ɵ0 = customDefaultOptions;
var ItemGridScrollModule = /** @class */ (function () {
    function ItemGridScrollModule() {
    }
    return ItemGridScrollModule;
}());
export { ItemGridScrollModule };
export { ɵ0 };
